import { AxiosResponse } from "axios";
import { apiClient } from "../apis/apiClient";
import {
  FavoriteEntityType,
  BulkFavoriteEntitiesResponse,
  FavoriteActionResponse,
} from "../types/favorites";

export const favoritesAPI = {
  // Add to favorites
  add: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.post(`/rest/favorites/${entityType}/${entityId}`);
  },

  // Remove from favorites
  remove: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.delete(`/rest/favorites/${entityType}/${entityId}`);
  },

  // Toggle favorite status
  toggle: (
    entityType: FavoriteEntityType,
    entityId: number | string
  ): Promise<AxiosResponse<FavoriteActionResponse>> => {
    return apiClient.put(`/rest/favorites/toggle/${entityType}/${entityId}`);
  },

  // Get favorite entity IDs
  getFavoriteEntityIds: (
    entityType: FavoriteEntityType
  ): Promise<AxiosResponse<number[]>> => {
    return apiClient.get(`/rest/favorites/ids/${entityType}`);
  },

  // Get all favorite entities in one bulk call
  getAllFavoriteEntities: (): Promise<
    AxiosResponse<string | BulkFavoriteEntitiesResponse>
  > => {
    return apiClient.get("/rest/favorites/entities/bulk");
  },
};

export default favoritesAPI;
